export const defaultFormValues = {
  title: "",
  description: "",
  original: undefined,
  regions: [],
};
